<template>
    <div class="search-no-results-found" data-testid="no-result-found">
        <div>
            <MaltImg src="/rebranding2020/illustrations/error-page-optimized.png" alt="No result" width="126" />
        </div>
        <div>
            <h2 class="search-no-results-found__title">
                {{ $t('search.no.results.v2') }}
            </h2>
            <div class="search-no-results-found__text">
                <p
                    v-if="spellingCorrection"
                    data-testid="no-result-found-spelling-correction"
                    v-html="$t('search.no.results.v2.advice.spelling.correction', [spellingCorrection.searchUrl, spellingCorrection.suggestion])"
                ></p>
                <p v-else>{{ $t('search.no.results.v2.advice.common') }}</p>

                <p v-if="!currentIdentityIsFreelance" data-testid="no-result-found-client-advice">
                    {{ $t('search.no.results.v2.advice.clients') }}
                </p>
            </div>
            <VJoyButton
                v-if="!currentIdentityIsFreelance"
                variant="secondary"
                :href="urlToAdvancedSearch"
                data-testid="no-result-found-pdf-to-brief-link"
            >
                {{ $t('search.no.results.v2.advice.clients.cta') }}
            </VJoyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {MaltImg} from '#components';
    import {useAuth} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useLinksFrom} from './useLinks';
    import {useSearchFeaturesStore} from '../stores/search-features.store';

    const {currentIdentityIsFreelance} = useAuth();
    const searchFeaturesStore = useSearchFeaturesStore();
    const {spellingCorrection} = storeToRefs(searchFeaturesStore);
    const {urlToAdvancedSearch} = useLinksFrom('search_no_results');
</script>

<style scoped lang="scss">
    @use '@malt/joy-entrypoint' as joy;

    .search-no-results-found {
        min-height: 40vh;
        display: flex;
        flex-flow: row wrap;
        gap: var(--joy-core-spacing-8);
        align-content: center;
        justify-content: flex-start;
        @include joy.screen_md(min) {
            padding: var(--joy-core-spacing-8);
        }

        &__title {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-secondary-200);
            margin-bottom: var(--joy-core-spacing-3);
        }

        &__text {
            margin-bottom: var(--joy-core-spacing-6);
        }
    }
</style>
